/* tslint:disable */
/* eslint-disable */
export enum WorkTaxRateCategoryEnum {
  Standard = 'standard',
  Reduced = 'reduced',
  Special = 'special',
  Exempt = 'exempt'
}
